module.exports = {"140823100":"桐城镇","140823101":"郭家庄镇","140823102":"畖底镇","140823103":"薛店镇","140823104":"东镇镇","140823105":"礼元镇","140823106":"河底镇","140823200":"神柏乡","140823201":"阳隅乡","140823202":"侯村乡","140823203":"裴社乡","140823204":"后宫乡","140823205":"石门乡","140823400":"社区管理办公室"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140823.json
// module id = 295
// module chunks = 0